import { AssessmentNavbar } from "#components/AssessmentNavbar.tsx";
import { useIsProjectTabsLayout } from "#hooks/useIsProjectTabsLayout.ts";
import { AssessmentCardNav } from "./AssessmentCardNav.tsx";

export function ProjectAssessmentNavbar() {
    const isProjectTabsLayout = useIsProjectTabsLayout();

    return isProjectTabsLayout ? <AssessmentCardNav /> : <AssessmentNavbar />;
}
